module.exports = __webpack_public_path__ + "img/articles_icon.a6e3d0f4.png";